import Base from './base';

import { AUDIO_TAG_NAME, AUDIO_CLASS_NAME } from '../../classnames/blog';

export default class Audio extends Base {
  tagName = AUDIO_TAG_NAME;
  placeholderSourceAttribute = 'source';
  elementName = 'audio';
  sourceTypes = ['audio/ogg', 'audio/mpeg', 'audio/wav'];
  attributes = { controls: '', preload: 'none' };

  buildNode = (placeholder) => {
    const src = placeholder.getAttribute(this.placeholderSourceAttribute);
    const newNode = document.createElement(this.elementName);

    newNode.classList.add(AUDIO_CLASS_NAME);

    this.setAttributes(newNode);
    this.buildSources(newNode, src);

    return newNode;
  };

  setAttributes = (audioNode) => {
    Object.keys(this.attributes).forEach((name) => audioNode.setAttribute(name, this.attributes[name]));
  };

  buildSources = (audioNode, src) => {
    this.sourceTypes.forEach((type) => this.buildSource(audioNode, type, src));
  };

  buildSource = (audioNode, type, src) => {
    const source = document.createElement('source');

    source.setAttribute('src', src);
    source.setAttribute('type', type);

    audioNode.appendChild(source);
  };
}
